<ejs-dialog
  target=".dialogs"
  class="simple-dialog"
  [cssClass]="'assistance-dialog'"
  [animationSettings]="dialogService.getAnimationSettings()"
  [resizeHandles]="dialogService.getResizeHandleDirection()"
  [position]="dialogService.getPosition()"
  [isModal]="true"
  [visible]="visible"
  [allowDragging]="false"
  [width]="'360px'"
  [height]="'auto'"
  [zIndex]="999"
  [showCloseIcon]="true"
  (beforeClose)="close()"
>
  <ng-template #header>
    <div class="d-flex align-items-center justify-content-center">
      <app-headline
        [title]="('ASSIST' | translate)"
        [type]="'h5'"
        [class]="'text-primary'"
      ></app-headline>
      <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'" [text]="('APPASSISTANCEHELP' | translate)" [width]="'300px'" [height]="'100px'" [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
    </div>
  </ng-template>

  <ng-template #content>
    <div class="d-flex flex-column gap-2 p-3">

      <a
        [href]="assistanceUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="assistance-option"
      >
        <div class="mts-icon notranslate assistance-option-icon" translate="no">edit_note</div>

        <div class="d-flex flex-column">
            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'" [fontDecoration]="'fw-bold'">{{ ('HUMANSTARSASSISTANCE' | translate) }}</app-content>
            <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'">{{ ('HUMANSTARSASSISTANCEDESCRIPTION' | translate) }}</app-content>
        </div>
      </a>

      <a
        [href]="calendarUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="assistance-option"
      >
        <div class="mts-icon notranslate assistance-option-icon" translate="no">calendar_month</div>
        <div class="d-flex flex-column">
            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'" [fontDecoration]="'fw-bold'"> {{ ('BOOKAPPOINTMENT' | translate) }}</app-content>
            <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'">{{ ('BOOKAPPOINTMENTDESCRIPTION' | translate) }}</app-content>
        </div>
      </a>

    </div>
  </ng-template>
</ejs-dialog>